import { VueRenderer } from '@tiptap/vue-3'
import tippy from 'tippy.js'

import MentionList from './MentionList.vue'

export default function createSuggestion ({ getItems, tippyOptions = {} } = {}) {
  const safeGetItems = typeof getItems === 'function'
    ? getItems
    : ({ query }) => []

  const mergedTippyOptions = { zIndex: 90000, ...tippyOptions }

  return {
    items: ({ query }) => {
      const items = safeGetItems({ query }) || []
      return items
    },

    tippyOptions: () => mergedTippyOptions,
    char: '{',

    render: () => {
      let component
      let popup

      return {
        onStart: (props) => {
          component = new VueRenderer(MentionList, {
            editor: props.editor,
            props,
          })

          if (!props.clientRect) {
            return
          }

          popup = tippy('body', {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: 'manual',
            placement: 'bottom-start',
            ...mergedTippyOptions,
          })
        },

        onUpdate (props) {
          component?.updateProps(props)

          if (!props.clientRect) {
            return
          }

          popup?.[0]?.setProps({
            getReferenceClientRect: props.clientRect,
          })
        },

        onKeyDown (props) {
          if (props.event.key === 'Escape') {
            popup?.[0]?.hide()

            return true
          }

          return component?.ref?.onKeyDown(props) ?? false
        },

        onExit () {
          popup?.[0]?.destroy()
          component?.destroy()
        },
      }
    },
  }
}
